import { Icon20Cancel, Icon20HistoryBackwardOutline } from '@vkontakte/icons';
import { Button, Cell, Headline, List, SizeType } from '@vkontakte/vkui';
import { Popper } from '@vkontakte/vkui/unstable';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { searchHistoryClear, searchHistoryRemoveItem } from 'reactApp/modules/search/search.module';
import { IHistoryItem } from 'reactApp/modules/search/search.types';

import { useWebSearchClickAway } from '../hooks/useWebSearchClickAway';
import styles from './SearchSuggests.css';

interface IProps {
    rootRef: React.RefObject<HTMLElement>;
    targetRef: React.RefObject<HTMLDivElement>;
    items: IHistoryItem[];
    onClick: (value: string) => void;
    onClickAway: () => void;
}

export const SearchSuggests: React.FC<IProps> = ({ rootRef, targetRef, items, onClick, onClickAway }) => {
    const ref = useRef<HTMLDivElement>(null);
    useWebSearchClickAway({ rootRef, ref, onClickAway });
    const storeDispatch = useDispatch();

    const onClear = () => {
        storeDispatch(searchHistoryClear());
    };

    return (
        <Popper sameWidth offsetDistance={10} placement="bottom-start" targetRef={targetRef} forcePortal={false}>
            <div ref={ref} id="dropdownList" data-qa-id="search-suggests">
                <List className={styles.container}>
                    <Cell
                        sizeY={SizeType.COMPACT}
                        after={
                            <Button className={styles.resetButton} hasHover={false} mode="tertiary" onClick={onClear}>
                                <Headline>Очистить</Headline>
                            </Button>
                        }
                    >
                        <Headline className={styles.header} level="1" weight="2">
                            История поиска
                        </Headline>
                    </Cell>
                    {items.map(({ text }) => (
                        <Cell
                            hoverMode={styles.hover}
                            sizeY={SizeType.COMPACT}
                            key={text}
                            before={<Icon20HistoryBackwardOutline fill="#A5A7AD" />}
                            after={
                                <div
                                    className={styles.clearButton}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        storeDispatch(searchHistoryRemoveItem(text));
                                    }}
                                >
                                    <Icon20Cancel />
                                </div>
                            }
                            onClick={() => onClick(text)}
                        >
                            {text}
                        </Cell>
                    ))}
                </List>
            </div>
        </Popper>
    );
};

SearchSuggests.displayName = 'SearchSuggests';
